import { useLocalStorage } from '@mantine/hooks';

import { Event } from 'models';
import { QrScanHelpers } from 'helpers/QrScanHelpers';
import { UserHelpers } from 'helpers/UserHelpers';

import { useCurrentUser } from 'hooks/use-current-user';
import { useQrScans } from 'hooks/use-qr-scans';

// Only narrows to an event when one is passed, so the Showtime page keeps listing scans from every event.
const useSavedProfiles = (event?: Event | null) => {
    const [_email] = useLocalStorage<string | undefined>({
        key: UserHelpers.localStorageKey.email,
    });
    const email = _email !== 'undefined' ? _email : undefined;

    const user = useCurrentUser();

    const { qrScans, ...swr } = useQrScans({ email, userId: user?.id, eventId: event?.id });

    return { ...swr, qrScans, profileScans: qrScans.filter(QrScanHelpers.isProfileScan) };
};

export { useSavedProfiles };
